<div id="error-modal">
  <div mat-dialog-title class="dialog-title" id="errorTitle"><mat-icon class="with-text">error_outline</mat-icon>{{ data.title | translate:locale.language }}</div>
  <div mat-dialog-content>
    <div class="modal-message" [innerHTML]="data.message | translate:locale.language"></div>
    <div *ngIf="data.error?.length" class="modal-error">
      <div>{{ 'Problem Details:' | translate:locale.language }}</div>
      <div>
        <blockquote *ngIf="data.error?.length">{{ data.error | translate:locale.language }}</blockquote>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="button-row right">
    <button mat-raised-button color="primary" id="ok" [mat-dialog-close]="true">{{ (data.ok || 'OK') | translate:locale.language }}</button>
  </div>
</div>